module.exports = __webpack_public_path__ + "img/features03-01.bbecf7f.png";